import {
    LOG_IN,
    LOG_IN_SUCCESS,
    LOG_OUT,
    LOG_OUT_SUCCESS,
    SHOW_LOGIN_DIALOG,
    CLOSE_LOGIN_DIALOG,
    LOG_IN_FAIL,
    CHANGE_PASSWORD_FAILURE,
    CHANGE_PASSWORD_SUCCESS,
    RESET_CHANGE_PASSWORD_FORM,
    EXTEND_SESSION_SUCCESS,
    RESET_FORGOT_PASSWORD_FORM,
    FORGOT_PASSWORD,
    RESET_USER_PASSWORD_FAILED
} from './SessionActionTypes'
import store from 'store2'

export const initialSessionState = () => ({
    loggedInUser: store.get('ogonremiss.auth.loggedInUser') || null,
    organizationId: store.get('ogonremiss.auth.organizationId') || null,
    organizationName: store.get('ogonremiss.auth.organizationName') || null,
    jwt: store.get('ogonremiss.auth.jwt') || null,
    expiresUTC: store.get('ogonremiss.auth.expiresUTC') || null,
    roles: store.get('ogonremiss.auth.roles') || null,
    loggingIn: false,
    loggingOut: false,
    loginDialogOpen: false,
    loginErrorMessage: null,
    forgotPasswordModel: {
        forgotPasswordError: null,
        forgotPasswordInfo: null,
        // forgotPasswordForm: {
        //     currentPassword: null,
        //     newPassword: null,
        //     newPasswordRetype: null,
        // }
    },
    changePasswordModel: {
        changePasswordError: null,
        changePasswordInfo: null,
        // changePasswordForm: {
        //     currentPassword: null,
        //     newPassword: null,
        //     newPasswordRetype: null,
        // }
    },
});

const session = (state = initialSessionState(), action) => {
    switch (action.type) {
        case LOG_IN:
            return {
                ...state,
                loggingIn: true,
                loginErrorMessage: null,
            }
        case LOG_IN_SUCCESS:
            store.set('ogonremiss.auth.jwt', action.auth.jwt)
            store.set('ogonremiss.auth.loggedInUser', action.auth.username)
            store.set('ogonremiss.auth.organizationId', action.auth.organizationId)
            store.set('ogonremiss.auth.organizationName', action.auth.organizationName)
            store.set('ogonremiss.auth.expiresUTC', action.auth.expiresUTC)
            store.set('ogonremiss.auth.roles', action.auth.roles)
            return {
                ...state,
                loggedInUser: action.auth.username,
                organizationId: action.auth.organizationId,
                organizationName: action.auth.organizationName,
                jwt: action.auth.jwt,
                expiresUTC: action.auth.expiresUTC,
                roles: action.auth.roles,
                loggingIn: false,
                loginDialogOpen: false,
            }
        case EXTEND_SESSION_SUCCESS:
            store.set('ogonremiss.auth.jwt', action.auth.jwt)
            store.set('ogonremiss.auth.loggedInUser', action.auth.username)
            store.set('ogonremiss.auth.organizationId', action.auth.organizationId)
            store.set('ogonremiss.auth.organizationName', action.auth.organizationName)
            store.set('ogonremiss.auth.expiresUTC', action.auth.expiresUTC)
            store.set('ogonremiss.auth.roles', action.auth.roles)
            return {
                ...state,
                loggedInUser: action.auth.username,
                organizationId: action.auth.organizationId,
                organizationName: action.auth.organizationName,
                jwt: action.auth.jwt,
                expiresUTC: action.auth.expiresUTC,
                roles: action.auth.roles,
                loggingIn: false,
                loginDialogOpen: false,
            }
        case LOG_IN_FAIL:
            return {
                ...state,
                loggingIn: false,
                loginErrorMessage: 'Inloggning misslyckades, kontrollera uppgifterna och testa igen.',
            }
        case LOG_OUT:
            return {
                ...state,
                loggingOut: true,
            }
        case LOG_OUT_SUCCESS:
            store.namespace('ogonremiss.auth').clearAll()
            return {
                ...state,
                loggedInUser: null,
                jwt: null,
                expiresUTC: null,
                loggingOut: false,
            }
        case SHOW_LOGIN_DIALOG:
            return {
                ...state,
                loginDialogOpen: true,
                loginErrorMessage: null,
            }
        case CLOSE_LOGIN_DIALOG:
            return {
                ...state,
                loginDialogOpen: false,
                loginErrorMessage: null,
            }
        case CHANGE_PASSWORD_FAILURE:
            return {
                ...state,
                changePasswordModel: {
                    ...state.changePasswordModel,
                    changePasswordError: action.errorMessage,
                    changePasswordInfo: null,
                    // changePasswordForm: initialUsersState().changePasswordModel.changePasswordForm,
                }
            }
        case CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                changePasswordModel: {
                    ...state.changePasswordModel,
                    changePasswordError: null,
                    changePasswordInfo: "Lösenordet uppdaterades",
                    // changePasswordForm: initialUsersState().changePasswordModel.changePasswordForm,
                }
            }
        case RESET_CHANGE_PASSWORD_FORM:
            return {
                ...state,
                changePasswordModel: {
                    ...state.changePasswordModel,
                    changePasswordError: null,
                    changePasswordInfo: null,
                    // changePasswordForm: initialUsersState().changePasswordModel.changePasswordForm,
                }
            }
        case FORGOT_PASSWORD:
            return {
                ...state,
                loginDialogOpen: false,
            }
        case RESET_FORGOT_PASSWORD_FORM:
            return {
                ...state,
                forgotPasswordModel: {
                    ...state.forgotPasswordModel,
                    forgotPasswordError: null,
                    forgotPasswordInfo: null,
                    // changePasswordForm: initialUsersState().changePasswordModel.changePasswordForm,
                }
            }
        case RESET_USER_PASSWORD_FAILED:
            return {
                ...state,
                forgotPasswordModel: {
                    ...state.forgotPasswordModel,
                    forgotPasswordError: action.errorMessage,
                    forgotPasswordInfo: null,
                    // changePasswordForm: initialUsersState().changePasswordModel.changePasswordForm,
                }
            }
        // case RESET_USER_PASSWORD_FAILED:
        //     return {
        //         ...state,
        //         forgotPasswordModel: {
        //             ...state.forgotPasswordModel,
        //             forgotPasswordError: action.errorMessage,
        //             forgotPasswordInfo: null,
        //             // changePasswordForm: initialUsersState().changePasswordModel.changePasswordForm,
        //         }
        //     }
        default:
            return state;
    }
}
export default session;